// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"SearchInput_searchInput__TDwXr","input":"SearchInput_input__tzmuw"};